module.exports = __webpack_public_path__ + "static/media/logoCRI_modifie_110x43.cb99a3c3.png";